import styled from 'styled-components'

export const LoadindContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`
export const ScreenContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`
export const BreakWordParagraph = styled.p`
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin: 0;
  padding: 0;
`
